import { Routes, Route } from "react-router-dom";
import ServersListPage from "./list";
import AddServerPage from "./add";
import EditServerPage from "./edit";
import ViewServerPage from "./view";

function ServersPage() {
	return (
		<Routes>
			<Route path="/" element={<ServersListPage />} />
			<Route path="/add" element={<AddServerPage />} />
			<Route path="/:id/edit" element={<EditServerPage />} />
			<Route path="/:id" element={<ViewServerPage />} />
		</Routes>
	);
}

export default ServersPage;
